import CursorInfo from './CursorInfo';

export default CursorInfo;
